declare namespace $ {

	type $shm_check_all__title_shm_check_list_only_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_check_all['title'] >
	>
	type $shm_check_all__checks_shm_check_list_only_2 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['toggles'] >
		,
		ReturnType< $shm_check_all['checks'] >
	>
	type $mol_list__rows_shm_check_list_only_3 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['checks'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_check_list_only_4 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['check_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_check_list_only_5 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['check_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_check_list_only_6 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_check_list_only_7 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['only_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_check_list_only_8 = $mol_type_enforce<
		ReturnType< $shm_check_list_only['only'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_check_list_only extends $mol_list {
		All( ): $shm_check_all
		checks( ): readonly(any)[]
		Checks( ): $mol_list
		check_content( id: any): readonly(any)[]
		check_title( id: any): string
		checked( id: any, next?: boolean ): boolean
		only( id: any, next?: any ): any
		options( ): readonly(string)[]
		value( next?: readonly(string)[] ): readonly(string)[]
		toggles( ): readonly($mol_check)[]
		only_title( ): string
		only_visible( ): boolean
		inline( ): boolean
		attr( ): ({ 
			'shm_check_list_only_inline': ReturnType< $shm_check_list_only['inline'] >,
		})  & ReturnType< $mol_list['attr'] >
		rows( ): readonly(any)[]
		Check( id: any): $mol_view
		Toggle( id: any): $mol_check_box
		Only( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=only.view.tree.d.ts.map